import { useMemo } from 'react';

import { useGoldConfig } from '@jane/shared/data-access';

export const useStoreHasGoldConfig = (storeId: string | number) => {
  const { data: goldConfig, isLoading: isLoadingGoldConfig } = useGoldConfig();

  return useMemo(() => {
    if (isLoadingGoldConfig || !goldConfig) return false;
    return goldConfig.store_ids.includes(Number(storeId));
  }, [goldConfig, isLoadingGoldConfig, storeId]);
};
